import { ClearAction, PushAction, RemoveAction } from './flashMessages';

export function pushFlashMessage(message: FlashMessageType): PushAction {
  return {
    type: 'PUSH_FLASH_MESSAGE',
    message,
  };
}

export function removeFlashMessage(id: string): RemoveAction {
  return {
    type: 'REMOVE_FLASH_MESSAGE',
    id,
  };
}

export function clearFlashMessages(): ClearAction {
  return {
    type: 'CLEAR_FLASH_MESSAGES',
  };
}
